export default {
      id: "download-video-usage",
      viewBox: "0 0 34 25",
      url: __webpack_public_path__ + "img/icons.svg#download-video",
      toString: function () {
        return this.url;
      }
    }